// extracted by mini-css-extract-plugin
export default {"content":"PremiumRequiredModal_content__gUsPH","dialogText":"PremiumRequiredModal_dialogText__ZRAyz"};